<template>
  <div id="app">
    <div class="app_wrapper" :id="$store.state.device == 'desktop' ? '' : 'mobile'">
      <!-- 只在非下载页面显示头部 -->
      <div class="header" v-if="!isDownloadPage">
        <div class="wrap_center">
          <h1><img src="./assets/logo.png" /></h1>
          <Icon type="md-menu" class="animate__fadeOut" v-if="!shownav" @click="shownavlist" />
          <Icon type="md-close" class="animate__fadeOut" v-if="shownav" />
          <div class="nav" ref="nav" :class="shownav ? 'navshow' : ''">
            <ul>
              <li v-for="item in navarr" :key="item.id" :class="currentNav == item.id ? 'current animate__slideInDown' : ''
                " @click="changeNav(item)">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="routercontent" :class="{ 'no-header-padding': isDownloadPage }">
        <router-view />
      </div>

      <!-- 只在非下载页面显示底部 -->
      <div class="footer" v-if="!isDownloadPage">
        <div class="footer_top wrap_center">
          <ul v-if="alldata">
            <li v-for="item in alldata.index.servicearr" :key="item.id">
              <i class="iconfont icon-kefu" v-if="item.id == 1"></i>
              <i class="iconfont icon-jinqian" v-else-if="item.id == 2"></i>
              <i class="iconfont icon-chanpin" v-else-if="item.id == 3"></i>
              <i class="iconfont icon-VIP" v-else-if="item.id == 4"></i>
              {{ item.name }}
            </li>
          </ul>
          <i class="line"></i>
        </div>
        <div class="footer_bottom wrap_center">
          <div class="detail">
            <h1><img src="./assets/logo02.jpg" /></h1>
            <div>
              <p>保定金巢数据科技有限公司</p>
              <p>地址:河北省保定市高新区华安保定高新数智谷9号楼2单元</p>
              <a style="color: #fff" href="https://beian.miit.gov.cn/">备案号：冀ICP备2022023174号-1</a>
            </div>
          </div>
          <div class="qr_detail">
            <ul v-if="alldata">
              <li v-for="item in alldata.index.qrarr" :key="item.id">
                <img :src="item.img" alt="" />
                <p>{{ item.name }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResizeMixin from "../src/ResizeHandler";
import alldata from "./views/alldata";

export default {
  name: "app",
  data() {
    return {
      alldata: null,
      navarr: [
        { id: 1, name: "首页", url: "/home" },
        { id: 2, name: "产品介绍", url: "/product" },
        { id: 3, name: "业务招募", url: "/business" },
        { id: 4, name: "下载中心", url: "/download" },
        { id: 5, name: "教程", url: "/Course" },
        { id: 6, name: "品牌定制", url: "/brand" },
        { id: 7, name: "大客户通道", url: "/connection" },
      ],
      currentNav: 1,
      shownav: false,
    };
  },
  mixins: [ResizeMixin],
  computed: {
    // 判断当前是否为下载页面
    isDownloadPage() {
      return this.$route.path.includes('/mirror/');
    }
  },
  watch: {
    // 监听路由变化，更新当前导航状态
    '$route'(to) {
      console.log(to, 'to')
      if (to.path.includes('/mirror/')) {
        // 如果进入下载页面，可以设置一个特殊状态
        sessionStorage.setItem("currentNav", 0);
      } else {
        // 根据路径设置当前导航
        const navItem = this.navarr.find(item => item.url === to.path);
        if (navItem) {
          this.currentNav = navItem.id;
        }
      }
    }
  },
  mounted() {
    this.alldata = alldata;
    if (sessionStorage.getItem("currentNav")) {
      this.currentNav = sessionStorage.getItem("currentNav");
    } else {
      this.currentNav = 1;
    }
    try {
      this.$router.replace(this.navarr[this.currentNav - 1].url);
    } catch (err) {
    }
  },
  methods: {
    //切换导航
    changeNav(data) {
      this.currentNav = data.id;
      sessionStorage.setItem("currentNav", data.id);
      this.shownav = false;
      try {
        this.$router.replace(data.url);
      } catch (err) {
      }
    },
    //手机端点击按钮展示导航
    shownavlist() {
      this.shownav = true;
    },
  },
};
</script>
<style lang="scss">
@import "../node_modules/iview/dist/styles/iview.css";

.ivu-modal-body {
  max-height: 80vh !important;
  overflow-y: auto;
}

.ivu-modal-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ivu-modal {
  top: 0px !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background: #fff;
  // min-width: 1280px;
  font-size: 14px;
  margin: 0;
  padding: 0;
  font-family: "PingFang SC", "\5FAE\8F6F\96C5\9ED1", "Microsoft Yahei",
    "Hiragino Sans GB", tahoma, arial, "\5B8B\4F53";
}

ul,
div,
h1,
h2,
h3,
h4,
p,
i,
span,
li,
ol {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

body {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

//居中限制
.wrap_center {
  width: 1280px;
  margin: 0 auto;
}

// 头部
.header {
  height: 68px !important;
  background: #f2f2f2;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;

  .wrap_center {
    display: flex;
    justify-content: space-between;
    height: 68px;
    align-items: center;
  }

  h1 img {
    width: 167px;
  }

  .ivu-icon.ivu-icon-md-menu {
    display: none;
  }

  .nav ul {
    display: flex;
    justify-content: space-between;

    li {
      padding: 10px 30px;
      border-radius: 30px;
      font-size: 16px;
      // width: 70px;
      margin: 0 5px;
      text-align: center;
      cursor: pointer;
    }

    li:hover {
      background: #d5d5d5;
      transition: all 1s ease;
    }

    li.current {
      background: #0c4a9d;
      color: #fff;
      font-weight: bold;
    }
  }
}

.routercontent {
  padding-top: 67px;
  min-height: 800px;

  &.no-header-padding {
    padding-top: 0;
  }
}

// footer
.footer {
  background: #1e2126;
  padding: 60px 0;
  color: #fff;

  .footer_top {
    ul {
      display: flex;
      justify-content: space-between;

      .iconfont {
        margin-right: 3px;
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background: #fff;
      display: block;
      margin: 30px 0;
    }
  }

  .footer_bottom {
    display: flex;
    justify-content: space-between;

    .detail {
      display: flex;
      justify-content: space-between;
      align-items: center;

      >div {
        margin-left: 25px;
        line-height: 28px;
      }

      img {
        width: 120px;
        // background-color: #fff;
        // padding: 5px 10px;
      }
    }

    .qr_detail {
      ul {
        width: 700px;
        display: flex;
        justify-content: space-between;
        text-align: center;
      }

      img {
        width: 110px;
        height: 110px;
      }
    }
  }
}

//标题
.titbox {
  color: #333;
  text-align: center;

  .content_title {
    font-size: 34px;
    margin-bottom: 30px;
    font-weight: bold;
  }

  p {
    font-size: 18px;
    color: #666;
    width: 780px;
    margin: 20px auto;
    line-height: 30px;
  }
}

.ivu-tabs-nav-wrap {
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;

    .ivu-tabs-nav .ivu-tabs-tab {
      font-size: 16px;
      padding: 8px 60px;
    }
  }
}

.ivu-spin-fix {
  background: rgba(0, 0, 0, 0.6);
}

@media (max-width: 992px) {

  /* 头部 */
  .header {
    height: 1.08rem;

    .wrap_center {
      width: auto !important;
      margin: 0 auto;
      padding: 0 0.5rem;
      height: 1.18rem;
      position: relative;

      >div.nav {
        height: calc(100vh - 1.12rem);
        display: none;
        position: fixed;
        background: rgba(0, 0, 0, 0.9);
        width: 100%;
        top: 1.18rem;
        left: 0;

        z-index: 60;
        color: #fff;
        padding: 0.5rem 0;

        ul {
          display: flex;
          flex-flow: column;

          li {
            height: auto;
            font-size: 0.4rem;
            line-height: 1.18rem;
            padding: 10px 0;
            border-radius: none;
            margin: 0 0.5rem;
          }
        }
      }

      >.nav.navshow {
        display: block;
        animation: fadeIn 0.5s 0.5s ease-out both;
      }

      h1 {
        font-size: 0.6rem;
        line-height: 1.18rem;
      }

      .ivu-icon-md-menu,
      .ivu-icon-md-close {
        display: inline-block;
        font-size: 0.6rem;
      }
    }
  }

  .footer {
    .footer_top {
      border-bottom: 0.01rem solid #fff;
      padding-bottom: 0.3rem;

      ul {
        flex-wrap: wrap;

        li {
          width: 50%;
          font-size: 0.3rem;
        }
      }

      .line {
        display: none;
      }
    }

    .footer_bottom {
      display: block;
      position: relative;
      height: 8.5rem;
      margin-top: 0.3rem;
      font-size: 0.32rem;

      .qr_detail {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;

          li {
            width: 50%;
            font-size: 0.32rem;
            margin-bottom: 0.2rem;

            img {
              width: 60%;
              height: auto;
            }
          }
        }
      }

      .detail {
        border-top: 0.01rem solid #fff;
        position: absolute;
        top: 6rem;
        height: auto;
        left: 0;
        display: block;

        h1 {
          display: none;
        }

        >div {
          line-height: 0.5rem;
          margin-top: 0.3rem;
          font-size: 0.32rem;
        }
      }
    }
  }

  //居中限制
  .wrap_center {
    width: 7.2rem;
    margin: 0 auto;
  }

  //标题
  .titbox {
    color: #333;
    text-align: center;

    .content_title {
      font-size: 0.7rem;
      margin-bottom: 0.3rem;
      font-weight: normal;
      line-height: 1rem;
    }

    p {
      font-size: 0.36rem;
      color: #666;
      width: 100%;
      margin: 0.2rem auto;
      line-height: 0.6rem;
    }
  }
}
</style>
